import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopPaymentMethodFragment = { __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined };

export type ShopPaymentFragment = { __typename: 'ShopPaymentObject', id: number, amount: number, currency: string, state: Types.PaymentState, referenceNumber: string, description: string, errorDescription?: string | null | undefined, publicAttributes?: any | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined } };

export type ShopVoucherPaymentBalanceFragment = { __typename: 'ShopVoucherPaymentBalanceObject', amount: number, currency: string };

export type ShopCreateCartPaymentMutationVariables = Types.Exact<{
  input: Types.ShopCreateCartPaymentInput;
}>;


export type ShopCreateCartPaymentMutation = { __typename: 'Mutation', shopCreateCartPayment: { __typename: 'ShopPaymentObject', id: number, amount: number, currency: string, state: Types.PaymentState, referenceNumber: string, description: string, errorDescription?: string | null | undefined, publicAttributes?: any | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined } } };

export type ShopCreateNewCartPaymentMutationVariables = Types.Exact<{
  input: Types.ShopCreateNewCartPaymentInput;
}>;


export type ShopCreateNewCartPaymentMutation = { __typename: 'Mutation', shopCreateNewCartPayment: { __typename: 'ShopPaymentObject', id: number, amount: number, currency: string, state: Types.PaymentState, referenceNumber: string, description: string, errorDescription?: string | null | undefined, publicAttributes?: any | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined } } };

export type ShopReconCheckoutPaymentQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ShopReconCheckoutPaymentQuery = { __typename: 'Query', shopReconCheckoutPayment: { __typename: 'ShopPaymentObject', id: number, amount: number, currency: string, state: Types.PaymentState, referenceNumber: string, description: string, errorDescription?: string | null | undefined, publicAttributes?: any | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined } } };

export type ShopPaymentQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ShopPaymentQuery = { __typename: 'Query', shopPayment: { __typename: 'ShopPaymentObject', id: number, amount: number, currency: string, state: Types.PaymentState, referenceNumber: string, description: string, errorDescription?: string | null | undefined, publicAttributes?: any | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined } } };

export type ShopPaymentMethodsQueryVariables = Types.Exact<{
  channelCode: Types.Scalars['String']['input'];
}>;


export type ShopPaymentMethodsQuery = { __typename: 'Query', shopPaymentMethods: Array<{ __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined }> };

export type ShopCheckVoucherPaymentBalanceQueryVariables = Types.Exact<{
  input: Types.ShopRedeemCartPaymentInput;
}>;


export type ShopCheckVoucherPaymentBalanceQuery = { __typename: 'Query', shopCheckVoucherPaymentBalance: { __typename: 'ShopVoucherPaymentBalanceObject', amount: number, currency: string } };

export type ShopRedeemCartPaymentMutationVariables = Types.Exact<{
  input: Types.ShopRedeemCartPaymentInput;
}>;


export type ShopRedeemCartPaymentMutation = { __typename: 'Mutation', shopRedeemCartPayment: { __typename: 'ShopPaymentObject', id: number, amount: number, currency: string, state: Types.PaymentState, referenceNumber: string, description: string, errorDescription?: string | null | undefined, publicAttributes?: any | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined } } };

export type ShopCancelCartPaymentMutationVariables = Types.Exact<{
  input: Types.ShopCancelCartPaymentInput;
}>;


export type ShopCancelCartPaymentMutation = { __typename: 'Mutation', shopCancelCartPayment: { __typename: 'ShopPaymentObject', id: number, amount: number, currency: string, state: Types.PaymentState, referenceNumber: string, description: string, errorDescription?: string | null | undefined, publicAttributes?: any | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined } } };

export const ShopPaymentMethodFragmentDoc = gql`
    fragment ShopPaymentMethod on ShopPaymentMethodObject {
  id
  code
  provider
  name
  canReuse
  expressCheckoutEnabled
  fullScreenPaymentEnabled
  publicAttributes {
    ... on StripePublicClientAttributes {
      apiKeyPublic
    }
  }
}
    `;
export const ShopPaymentFragmentDoc = gql`
    fragment ShopPayment on ShopPaymentObject {
  id
  amount
  currency
  state
  referenceNumber
  description
  errorDescription
  publicAttributes
  method {
    ...ShopPaymentMethod
  }
}
    ${ShopPaymentMethodFragmentDoc}`;
export const ShopVoucherPaymentBalanceFragmentDoc = gql`
    fragment ShopVoucherPaymentBalance on ShopVoucherPaymentBalanceObject {
  amount
  currency
}
    `;
export const ShopCreateCartPaymentDocument = gql`
    mutation ShopCreateCartPayment($input: ShopCreateCartPaymentInput!) {
  shopCreateCartPayment(input: $input) {
    ...ShopPayment
  }
}
    ${ShopPaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCreateCartPaymentGQL extends Apollo.Mutation<ShopCreateCartPaymentMutation, ShopCreateCartPaymentMutationVariables> {
    document = ShopCreateCartPaymentDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopCreateNewCartPaymentDocument = gql`
    mutation ShopCreateNewCartPayment($input: ShopCreateNewCartPaymentInput!) {
  shopCreateNewCartPayment(input: $input) {
    ...ShopPayment
  }
}
    ${ShopPaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCreateNewCartPaymentGQL extends Apollo.Mutation<ShopCreateNewCartPaymentMutation, ShopCreateNewCartPaymentMutationVariables> {
    document = ShopCreateNewCartPaymentDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopReconCheckoutPaymentDocument = gql`
    query ShopReconCheckoutPayment($id: Int!) {
  shopReconCheckoutPayment(id: $id) {
    ...ShopPayment
  }
}
    ${ShopPaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopReconCheckoutPaymentGQL extends Apollo.Query<ShopReconCheckoutPaymentQuery, ShopReconCheckoutPaymentQueryVariables> {
    document = ShopReconCheckoutPaymentDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopPaymentDocument = gql`
    query ShopPayment($id: Int!) {
  shopPayment(id: $id) {
    ...ShopPayment
  }
}
    ${ShopPaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopPaymentGQL extends Apollo.Query<ShopPaymentQuery, ShopPaymentQueryVariables> {
    document = ShopPaymentDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopPaymentMethodsDocument = gql`
    query ShopPaymentMethods($channelCode: String!) {
  shopPaymentMethods(channelCode: $channelCode) {
    ...ShopPaymentMethod
  }
}
    ${ShopPaymentMethodFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopPaymentMethodsGQL extends Apollo.Query<ShopPaymentMethodsQuery, ShopPaymentMethodsQueryVariables> {
    document = ShopPaymentMethodsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopCheckVoucherPaymentBalanceDocument = gql`
    query ShopCheckVoucherPaymentBalance($input: ShopRedeemCartPaymentInput!) {
  shopCheckVoucherPaymentBalance(input: $input) {
    ...ShopVoucherPaymentBalance
  }
}
    ${ShopVoucherPaymentBalanceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCheckVoucherPaymentBalanceGQL extends Apollo.Query<ShopCheckVoucherPaymentBalanceQuery, ShopCheckVoucherPaymentBalanceQueryVariables> {
    document = ShopCheckVoucherPaymentBalanceDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopRedeemCartPaymentDocument = gql`
    mutation ShopRedeemCartPayment($input: ShopRedeemCartPaymentInput!) {
  shopRedeemCartPayment(input: $input) {
    ...ShopPayment
  }
}
    ${ShopPaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopRedeemCartPaymentGQL extends Apollo.Mutation<ShopRedeemCartPaymentMutation, ShopRedeemCartPaymentMutationVariables> {
    document = ShopRedeemCartPaymentDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopCancelCartPaymentDocument = gql`
    mutation ShopCancelCartPayment($input: ShopCancelCartPaymentInput!) {
  shopCancelCartPayment(input: $input) {
    ...ShopPayment
  }
}
    ${ShopPaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCancelCartPaymentGQL extends Apollo.Mutation<ShopCancelCartPaymentMutation, ShopCancelCartPaymentMutationVariables> {
    document = ShopCancelCartPaymentDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }